<template>
  <el-upload
    :file-list="fileList"
    :action="actionUrlCustom"
    :headers="uploadHeaders"
    :accept="acceptByType"
    :limit="limit"
    :on-exceed="handleExceed"
    :on-success="handleUploadSuccess"
    :on-error="handleUploadError"
    :before-upload="beforeFileUpload"
    :before-remove="beforeRemove"
    :on-change="handleFileChange"
    :on-remove="handleFileRemove"
    list-type="picture-card"
    drag
  >
    <i class="el-icon-plus"></i>
  </el-upload>
</template>
<script>
import elUpload from '@/mixins/el-upload';

export default {
  mixins: [elUpload],
  props: {},
  data() {
    return {
      actionUrlCustom:
        this.$http.defaults.baseURL + '/business/common/file/uploadPandV',
      limit: 1,
      customAccept: ['bmp', 'png', 'jpg', 'gif', 'jpeg'],
    };
  },
  methods: {
    setFile(file) {
      return (this.fileList = [file]);
    },
    getFileUrl() {
      const file = this.fileList[0];
      return file
        ? file.response
          ? file.response.data.pictureUrl
          : file.url.replace(this.imageUrl, '')
        : '';
    },
    clear() {
      this.fileList = [];
    },
  },
};
</script>
<style lang="scss" scoped></style>
